// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#fitbase-widget .btn.enter-button>a{justify-content:center;color:#fff!important}#fitbase-widget .btn.enter-button>a i path{fill:#fff!important}.registration_form_request{flex-wrap:wrap}.registration_form_agree{flex:0 0 100%;max-width:100%}", ""]);
// Exports
module.exports = exports;
